import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import shimmerStyles from "../../Components/Skeleton/shimmer.module.css";
import styles from "./MenuCoursesSkeleton.module.css";

const ROW_WIDTHS = [
  styles.titleBarWide,
  styles.titleBarMedium,
  styles.titleBarNarrow,
  styles.titleBarMedium,
] as const;

type MenuCoursesSkeletonProps = {
  rows?: number;
};

function MenuCoursesSkeleton({ rows = 5 }: MenuCoursesSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div
      className={styles.root}
      role="status"
      aria-live="polite"
      aria-label={t("menu.loadingEducations")}
    >
      <div className={styles.list}>
        {Array.from({ length: rows }, (_, index) => (
          <div
            key={index}
            className={styles.row}
            data-testid="menu-course-skeleton-row"
            aria-hidden="true"
          >
            <div
              className={clsx(
                styles.titleBar,
                shimmerStyles.shimmer,
                ROW_WIDTHS[index % ROW_WIDTHS.length]
              )}
            />
            <div className={clsx(styles.progressRing, shimmerStyles.shimmer)} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default MenuCoursesSkeleton;
